var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout-default"
  }, [_c('h2', {
    staticClass: "h3 mb-25"
  }, [_vm._v("\n    Гарантия и возврат\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('ul', {
    staticClass: "bullet-list"
  }, _vm._l(_vm.links, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "bullet-list__item"
    }, [_c('nuxt-link', {
      staticClass: "link",
      attrs: {
        "to": item.link
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1);
  }), 0)]), _vm._v(" "), _c('h3', {
    staticClass: "h5 mt-19 mb-8"
  }, [_vm._v("\n    Рекомендуемые к прочтению статьи из закона «О защите прав потребителя»\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "p mb-16"
  }, [_c('ul', {
    staticClass: "bullet-list"
  }, _vm._l(_vm.lawLinks, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "bullet-list__item"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": item.link,
        "rel": "nofollow",
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "p mb-8"
  }, [_vm._v("\n    Просим отнестись с пониманием к тому, что наличие вирусов или неграмотно установленных программ на компьютерах и ноутбуках\n    неисправностью устройства не является, и проблема может быть устранена специалистами нашего сервисного центра за отдельную плату.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("\n    Мы рекомендуем приобретать антивирусные программы и другой софт вместе с оборудованием.\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }